import { useContext } from 'react';
import { useHistory } from "react-router-dom"
import { Link } from '@mui/material';
import { IState, ticketsContext } from "../../TicketsContext";
import { TicketQueues, TicketStatus } from "helpers/Enums";


let Clickable = (prop: { value: number, categoryId?: string, status?: string }) => {
    let history = useHistory<IState>();
    let { defaultSearch } = useContext(ticketsContext);

    return (
        <>
            {prop.value === 0 && '-'}
            {prop.value > 0 &&
                <Link
                    component="button"
                    onClick={() => history.push(
                        history.location.pathname,
                        {
                            search: {
                                ...defaultSearch,
                                ticketCategoryId: prop.categoryId || "",
                                status: prop.status ? [prop.status as TicketStatus] : [],
                                ticketQueue: TicketQueues.AdvancedSearch
                            },
                        }
                    )}
                >
                    {prop.value}
                </Link>
            }
        </>
    )
}
export default Clickable